import React, { useState } from 'react';

export default function LandingPage({ onGoToLogin }) {
  const [menuOpen, setMenuOpen] = useState(false);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <div style={{ background: '#060e1a', color: '#f0f4f8', fontFamily: 'Inter, sans-serif', minHeight: '100vh', overflowX: 'hidden' }}>

      {/* Navbar */}
      <nav style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100, background: 'rgba(6,14,26,0.95)', backdropFilter: 'blur(20px)', borderBottom: '1px solid rgba(201,168,76,0.12)', padding: '0 24px', height: 64, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <img src="/logo-mig.png" alt="MIG" style={{ width: 36, height: 36, objectFit: 'contain' }} />
          <div>
            <div style={{ fontWeight: 800, fontSize: '1rem', letterSpacing: '-0.02em' }}>
              <span style={{ color: '#c9a84c' }}>MIG</span> Security
            </div>
            <div style={{ fontSize: '0.6rem', color: '#4a6070', letterSpacing: '0.08em', textTransform: 'uppercase', display: window.innerWidth < 480 ? 'none' : 'block' }}>PT. Muhammad Ibrahim Group</div>
          </div>
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <div style={{ display: window.innerWidth < 600 ? 'none' : 'flex', gap: 24, marginRight: 16 }}>
            {['layanan', 'tentang', 'kontak'].map(s => (
              <button key={s} onClick={() => scrollTo(s)} style={{ background: 'none', border: 'none', color: '#8899aa', fontSize: '0.85rem', cursor: 'pointer', fontFamily: 'Inter, sans-serif', textTransform: 'capitalize' }}>
                {s.charAt(0).toUpperCase() + s.slice(1)}
              </button>
            ))}
          </div>
          <button onClick={onGoToLogin} style={{ background: 'linear-gradient(135deg, #c9a84c, #e8c96a)', border: 'none', borderRadius: 8, padding: '8px 20px', color: '#060e1a', fontWeight: 700, fontSize: '0.85rem', cursor: 'pointer', fontFamily: 'Inter, sans-serif' }}>
            Masuk
          </button>
        </div>
      </nav>

      {/* Hero Section */}
      <section style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '100px 24px 60px', textAlign: 'center', background: 'radial-gradient(ellipse at 50% 0%, rgba(201,168,76,0.08) 0%, transparent 60%), #060e1a', position: 'relative', overflow: 'hidden' }}>
        {/* Background decoration */}
        <div style={{ position: 'absolute', top: '20%', left: '10%', width: 300, height: 300, borderRadius: '50%', background: 'rgba(201,168,76,0.03)', filter: 'blur(60px)' }} />
        <div style={{ position: 'absolute', bottom: '20%', right: '10%', width: 400, height: 400, borderRadius: '50%', background: 'rgba(11,24,41,0.8)', filter: 'blur(80px)' }} />

        <img src="/logo-mig.png" alt="MIG Security" style={{ width: 140, height: 140, objectFit: 'contain', marginBottom: 32, filter: 'drop-shadow(0 0 30px rgba(201,168,76,0.3))' }} />

        <div style={{ fontSize: '0.8rem', color: '#c9a84c', fontWeight: 600, letterSpacing: '0.15em', textTransform: 'uppercase', marginBottom: 16, background: 'rgba(201,168,76,0.1)', border: '1px solid rgba(201,168,76,0.2)', borderRadius: 999, padding: '4px 16px', display: 'inline-block' }}>
          Terdaftar SK Kemenkumham AHU-0038017.AH.01.01.TAHUN 2026
        </div>

        <h1 style={{ fontSize: 'clamp(2rem, 6vw, 3.5rem)', fontWeight: 900, lineHeight: 1.1, letterSpacing: '-0.03em', marginBottom: 20, maxWidth: 700 }}>
          Profesional. Terlatih.<br />
          <span style={{ color: '#c9a84c' }}>Terpercaya.</span>
        </h1>

        <p style={{ fontSize: 'clamp(1rem, 2vw, 1.2rem)', color: '#8899aa', maxWidth: 560, lineHeight: 1.7, marginBottom: 40 }}>
          PT. Muhammad Ibrahim Group menyediakan layanan keamanan terpadu dengan sistem manajemen digital real-time untuk area Jakarta Selatan dan sekitarnya.
        </p>

        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', justifyContent: 'center' }}>
          <button onClick={onGoToLogin} style={{ background: 'linear-gradient(135deg, #c9a84c, #e8c96a)', border: 'none', borderRadius: 12, padding: '14px 32px', color: '#060e1a', fontWeight: 800, fontSize: '1rem', cursor: 'pointer', fontFamily: 'Inter, sans-serif', boxShadow: '0 8px 32px rgba(201,168,76,0.3)' }}>
            🛡️ Masuk ke Sistem
          </button>
          <button onClick={() => scrollTo('layanan')} style={{ background: 'transparent', border: '1px solid rgba(201,168,76,0.3)', borderRadius: 12, padding: '14px 32px', color: '#c9a84c', fontWeight: 600, fontSize: '1rem', cursor: 'pointer', fontFamily: 'Inter, sans-serif' }}>
            Pelajari Layanan →
          </button>
        </div>

        {/* Stats */}
        <div style={{ display: 'flex', gap: 48, marginTop: 64, flexWrap: 'wrap', justifyContent: 'center' }}>
          {[['24/7', 'Monitoring'], ['100%', 'Digital Report'], ['Real-time', 'GPS Tracking'], ['Terverifikasi', 'Kemenkumham']].map(([val, label]) => (
            <div key={label} style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '1.5rem', fontWeight: 800, color: '#c9a84c' }}>{val}</div>
              <div style={{ fontSize: '0.75rem', color: '#4a6070', marginTop: 4, textTransform: 'uppercase', letterSpacing: '0.06em' }}>{label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Layanan Section */}
      <section id="layanan" style={{ padding: '80px 24px', maxWidth: 1100, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 56 }}>
          <div style={{ fontSize: '0.75rem', color: '#c9a84c', fontWeight: 600, letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 12 }}>Layanan Kami</div>
          <h2 style={{ fontSize: 'clamp(1.75rem, 4vw, 2.5rem)', fontWeight: 800, letterSpacing: '-0.02em' }}>Solusi Keamanan Terpadu</h2>
          <p style={{ color: '#8899aa', marginTop: 12, maxWidth: 480, margin: '12px auto 0' }}>Didukung teknologi digital untuk transparansi dan akuntabilitas penuh</p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 20 }}>
          {[
            { icon: '👮', title: 'Pengamanan Area', desc: 'Personel keamanan terlatih dan bersertifikat untuk pengamanan gedung, perumahan, dan kawasan komersial di Jakarta Selatan.' },
            { icon: '📱', title: 'Sistem Digital Real-time', desc: 'Absensi berbasis GPS, laporan kejadian dengan foto bukti, dan dashboard monitoring yang dapat diakses kapan saja.' },
            { icon: '📋', title: 'Laporan Transparan', desc: 'Setiap kejadian terdokumentasi dengan audit trail lengkap — siapa yang menangani, kapan, dan bukti foto per tahap penanganan.' },
            { icon: '🔔', title: 'Notifikasi Instan', desc: 'Informasi langsung ke pihak terkait melalui WhatsApp dan sistem notifikasi digital saat terjadi insiden di wilayah Anda.' },
            { icon: '📊', title: 'Rekap Kehadiran', desc: 'Laporan kehadiran anggota security lengkap dengan jam masuk, keluar, durasi kerja, dan status harian yang dapat diunduh.' },
            { icon: '🗺️', title: 'Manajemen Wilayah', desc: 'Pengelolaan multi-wilayah dengan supervisor khusus per area, radius absensi tervalidasi GPS, dan koordinasi terpusat.' },
          ].map((item, i) => (
            <div key={i} style={{ background: 'linear-gradient(135deg, #112240, #0b1829)', border: '1px solid rgba(201,168,76,0.12)', borderRadius: 16, padding: 28, transition: 'border-color 0.2s', cursor: 'default' }}
              onMouseEnter={e => e.currentTarget.style.borderColor = 'rgba(201,168,76,0.3)'}
              onMouseLeave={e => e.currentTarget.style.borderColor = 'rgba(201,168,76,0.12)'}>
              <div style={{ fontSize: '2rem', marginBottom: 16 }}>{item.icon}</div>
              <h3 style={{ fontSize: '1.05rem', fontWeight: 700, marginBottom: 10 }}>{item.title}</h3>
              <p style={{ color: '#8899aa', fontSize: '0.875rem', lineHeight: 1.7, margin: 0 }}>{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Tentang Section */}
      <section id="tentang" style={{ padding: '80px 24px', background: 'linear-gradient(135deg, #0b1829, #060e1a)' }}>
        <div style={{ maxWidth: 900, margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 48, alignItems: 'center' }}>
          <div>
            <div style={{ fontSize: '0.75rem', color: '#c9a84c', fontWeight: 600, letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 12 }}>Tentang Kami</div>
            <h2 style={{ fontSize: 'clamp(1.5rem, 3vw, 2rem)', fontWeight: 800, letterSpacing: '-0.02em', marginBottom: 20 }}>PT. Muhammad Ibrahim Group</h2>
            <p style={{ color: '#8899aa', lineHeight: 1.8, marginBottom: 16, fontSize: '0.95rem' }}>
              Perusahaan jasa keamanan profesional yang terdaftar resmi di Kementerian Hukum dan HAM Republik Indonesia, berkomitmen memberikan layanan pengamanan terbaik dengan standar tinggi dan sistem manajemen berbasis teknologi.
            </p>
            <p style={{ color: '#8899aa', lineHeight: 1.8, fontSize: '0.95rem' }}>
              Dipimpin oleh tenaga ahli berpengalaman di bidang keamanan, kami melayani berbagai segmen mulai dari perumahan, perkantoran, hingga kawasan industri di Jakarta Selatan.
            </p>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            {[
              { label: 'Status Legalitas', value: 'Terdaftar Kemenkumham' },
              { label: 'SK', value: 'AHU-0038017.AH.01.01.TAHUN 2026' },
              { label: 'Direktur', value: 'Ibrahim Syarif' },
              { label: 'Komisaris', value: 'Muhammad Faizal' },
              { label: 'Chief Security Officer', value: 'Handoyo Setyotomo' },
              { label: 'Area Operasional', value: 'Jakarta Selatan & Sekitarnya' },
            ].map((item, i) => (
              <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '12px 16px', background: 'rgba(201,168,76,0.05)', border: '1px solid rgba(201,168,76,0.1)', borderRadius: 10 }}>
                <span style={{ color: '#4a6070', fontSize: '0.82rem' }}>{item.label}</span>
                <span style={{ color: '#f0f4f8', fontSize: '0.82rem', fontWeight: 600, textAlign: 'right', maxWidth: '55%' }}>{item.value}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Kontak Section */}
      <section id="kontak" style={{ padding: '80px 24px', maxWidth: 700, margin: '0 auto', textAlign: 'center' }}>
        <div style={{ fontSize: '0.75rem', color: '#c9a84c', fontWeight: 600, letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 12 }}>Hubungi Kami</div>
        <h2 style={{ fontSize: 'clamp(1.5rem, 3vw, 2rem)', fontWeight: 800, letterSpacing: '-0.02em', marginBottom: 16 }}>Tertarik Bekerja Sama?</h2>
        <p style={{ color: '#8899aa', lineHeight: 1.8, marginBottom: 40, fontSize: '0.95rem' }}>
          Konsultasikan kebutuhan keamanan Anda dengan tim kami. Kami siap memberikan solusi terbaik sesuai kebutuhan dan anggaran Anda.
        </p>

        <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap', marginBottom: 48 }}>
          <a href="https://t.me/fzl420" target="_blank" rel="noreferrer"
            style={{ display: 'flex', alignItems: 'center', gap: 10, background: 'rgba(0,136,204,0.1)', border: '1px solid rgba(0,136,204,0.3)', borderRadius: 12, padding: '12px 24px', color: '#60a5fa', textDecoration: 'none', fontWeight: 600, fontSize: '0.9rem' }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221l-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.447 1.394c-.16.16-.295.295-.605.295l.213-3.053 5.56-5.023c.242-.213-.054-.333-.373-.12l-6.871 4.326-2.962-.924c-.643-.204-.657-.643.136-.953l11.57-4.461c.537-.194 1.006.131.833.941z"/></svg>
            Telegram @fzl420
          </a>
          <a href="mailto:pt.muhammad.ibrahim@gmail.com"
            style={{ display: 'flex', alignItems: 'center', gap: 10, background: 'rgba(201,168,76,0.08)', border: '1px solid rgba(201,168,76,0.2)', borderRadius: 12, padding: '12px 24px', color: '#c9a84c', textDecoration: 'none', fontWeight: 600, fontSize: '0.9rem' }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
            pt.muhammad.ibrahim@gmail.com
          </a>
        </div>

        <button onClick={onGoToLogin} style={{ background: 'linear-gradient(135deg, #c9a84c, #e8c96a)', border: 'none', borderRadius: 12, padding: '16px 40px', color: '#060e1a', fontWeight: 800, fontSize: '1.05rem', cursor: 'pointer', fontFamily: 'Inter, sans-serif', boxShadow: '0 8px 32px rgba(201,168,76,0.25)' }}>
          🛡️ Masuk ke Sistem MIG Security
        </button>
      </section>

      {/* Footer */}
      <footer style={{ borderTop: '1px solid rgba(201,168,76,0.1)', padding: '32px 24px', textAlign: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, marginBottom: 12 }}>
          <img src="/logo-mig.png" alt="MIG" style={{ width: 28, height: 28, objectFit: 'contain' }} />
          <span style={{ fontWeight: 700, fontSize: '0.9rem' }}><span style={{ color: '#c9a84c' }}>MIG</span> Security</span>
        </div>
        <p style={{ color: '#4a6070', fontSize: '0.78rem', marginBottom: 8 }}>
          PT. Muhammad Ibrahim Group · Jakarta Selatan, DKI Jakarta
        </p>
        <p style={{ color: '#2d3f55', fontSize: '0.72rem' }}>
          © 2026 PT. Muhammad Ibrahim Group. All rights reserved.<br />
          <span style={{ color: '#2d3f55' }}>Developed by </span>
          <a href="https://t.me/fzl420" target="_blank" rel="noreferrer" style={{ color: '#c9a84c', textDecoration: 'none', fontWeight: 600 }}>FZL420</a>
        </p>
      </footer>
    </div>
  );
}
